import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const apiProviderData = [
  {
    id: 1,
    providerName: 'Twilio',
    apiKey: 'tw_************1234',
    baseUrl: 'https://api.twilio.com',
    category: 'SMS',
    status: 'Active',
    createdAt: '2025-01-05',
  },
  {
    id: 2,
    providerName: 'SendGrid',
    apiKey: 'sg_************5678',
    baseUrl: 'https://api.sendgrid.com',
    category: 'Email',
    status: 'Active',
    createdAt: '2025-01-06',
  },
  {
    id: 3,
    providerName: 'Google Maps',
    apiKey: 'gm_************9012',
    baseUrl: 'https://maps.googleapis.com',
    category: 'Location',
    status: 'Inactive',
    createdAt: '2025-01-07',
  },
  {
    id: 4,
    providerName: 'OpenAI',
    apiKey: 'oa_************3456',
    baseUrl: 'https://api.openai.com',
    category: 'AI',
    status: 'Active',
    createdAt: '2025-01-08',
  },
  {
    id: 5,
    providerName: 'Razorpay',
    apiKey: 'rz_************7890',
    baseUrl: 'https://api.razorpay.com',
    category: 'Payment',
    status: 'Active',
    createdAt: '2025-01-09',
  },
];

function ApiProviderList() {
  const [search, setSearch] = useState('');

  const filteredData = apiProviderData.filter(
    (item) =>
      item.providerName.toLowerCase().includes(search.toLowerCase()) ||
      item.category.toLowerCase().includes(search.toLowerCase())
  );

  const getStatusClass = (status) =>
    status === 'Active' ? 'badge bg-success' : 'badge bg-danger';

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>API Provider List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>API Provider List</span>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <Link to="/api-provider" className="add-btn">
            + Add Provider
          </Link>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">
            <div className="container">
              <div className="row mb-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control custumform"
                    placeholder="Search by Provider or Category..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Provider Name</th>
                      <th>API Key</th>
                      <th>Base URL</th>
                      <th>Category</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.providerName}</td>
                          <td>
                            <code>{item.apiKey}</code>
                          </td>
                          <td>
                            <a
                              href={item.baseUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.baseUrl}
                            </a>
                          </td>
                          <td>{item.category}</td>
                          <td>
                            <span className={getStatusClass(item.status)}>
                              {item.status}
                            </span>
                          </td>
                          <td>{item.createdAt}</td>
                          <td>
                            <Link
                              to={`/api-provider/${item.id}`}
                              className="btn btn-sm btn-primary me-2"
                            >
                              Edit
                            </Link>
                            <button className="btn btn-sm btn-danger">
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No API providers found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApiProviderList;